module.exports = __webpack_public_path__ + "img/start_5.931fc614.svg";